/* eslint-disable react/prop-types */
import React from "react";

import styles from "./enable-disable-all-blueprint-dashboard-toggles.module.scss";
import {
  EnableDisableAllBlueprintDashboardTogglesObj,
  useEnableDisableAllBlueprintDashboardTogglesHook,
} from "./use-enable-disable-all-blueprint-dashboard-toggles-hook";
import { TextButton } from "@src/components/atoms/buttons/text-button/text-button";
import { useI18N } from "@src/language/language-context";

interface BlueprintDashboardProps {
  useHook?: () => EnableDisableAllBlueprintDashboardTogglesObj;
}

const cssClassName = "enable-disable-all-blueprint-dashboard-toggles";

export const EnableDisableAllBlueprintDashboardToggles = ({
  useHook = useEnableDisableAllBlueprintDashboardTogglesHook,
}: BlueprintDashboardProps) => {
  const i18n = useI18N();
  const texts = {
    enableAllToggles: i18n(
      "modules.enableDisableAllBlueprintDashboardToggles.enableAllToggles",
    ),
    divider: i18n("modules.enableDisableAllBlueprintDashboardToggles.divider"),
    disableAllToggles: i18n(
      "modules.enableDisableAllBlueprintDashboardToggles.disableAllToggles",
    ),
    explaination: i18n(
      "modules.enableDisableAllBlueprintDashboardToggles.explaination",
    ),
  };

  const { onEnableAllToggles, onDisableAllToggles } = useHook();

  return (
    <div className={styles[cssClassName]}>
      <TextButton
        clickHandler={onEnableAllToggles}
        text={texts.enableAllToggles}
      />
      {texts.divider}
      <TextButton
        clickHandler={onDisableAllToggles}
        text={texts.disableAllToggles}
      />
      {` - ${texts.explaination}`}
    </div>
  );
};
